export enum layers {
  root = 1,
  modalMask = 99,
  modal = 100,
  menu = 101,
  cookieUse = 102,
  fullpageModal = 103
}